import { Dropdown, Form } from 'react-bootstrap';
import { useIsIOS } from '../../hooks/useIsIOS';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { searchFormChannelIdSelector } from '../../redux/search/form/selectors';
import { getPromotionSelector } from '../../redux/init/selectors';

export const NewspaperSelect = ({ selectedValue, onChange, show, onToggle, label, id, textStyle, disabled }) => {
  const selectedInitPromoValues = useSelector(getPromotionSelector);
  const [promoNewspapers, setPromoNewspapers] = useState();

  const [newspaperName, setNewspaperName] = useState('');
  const selectedChannelId = useSelector(searchFormChannelIdSelector);
  const channelSelected = !!selectedChannelId;

  const { isIOS } = useIsIOS();

  useEffect(() => {
    const newspapers = selectedInitPromoValues?.papercodes
      ? Object.entries(selectedInitPromoValues.papercodes)
          .map(([id, name]) => ({ id, name }))
          .sort((a, b) => a.id.localeCompare(b.id))
      : [];

    setPromoNewspapers(newspapers);
  }, [selectedInitPromoValues?.papercodes]);

  useEffect(() => {
    if (!selectedValue) {
      return setNewspaperName('Select a newspaper');
    }

    const selectedNewspaper = promoNewspapers?.find((el) => el.id === selectedValue);
    if (selectedNewspaper) {
      setNewspaperName(selectedNewspaper.name);
    }
  }, [selectedValue, promoNewspapers]);

  const regionOptions = promoNewspapers?.map(({ id, name }) => (
    <Form.Check
      key={id}
      id={id}
      type="radio"
      label={name}
      name="regionSelections"
      value={id}
      onChange={onChange}
      disabled={!channelSelected}
      className="bf-radio toggle"
      checked={selectedValue === id}
    />
  ));

  return (
    <Form.Group controlId={id} id="search-modal">
      <Form.Label className={`text-${textStyle}`}>
        <span>{label}</span>
      </Form.Label>
      {isIOS ? (
        <Form.Control
          as="select"
          className="p-0 toggle-popup"
          value={selectedValue}
          onChange={onChange}
          disabled={!channelSelected}
          tabIndex="0"
        >
          {promoNewspapers.map(({ id, name }) => (
            <option key={id} value={id} className="py-2 pl-3">
              {name}
            </option>
          ))}
        </Form.Control>
      ) : (
        <Dropdown show={show} onToggle={onToggle}>
          <Dropdown.Toggle
            as="button"
            type="button"
            className="toggle-popup is-dropdown"
            role="button"
            tabIndex="0"
            disabled={disabled}
          >
            <span>{newspaperName}</span>
          </Dropdown.Toggle>
          <Dropdown.Menu className="a-popup p-0 py-2">{regionOptions}</Dropdown.Menu>
        </Dropdown>
      )}
    </Form.Group>
  );
};
